import ApiService from './api-service';

const TimingService = {
  /**
   * @memberof TimingService
   * @name getTimings
   * @param {String} shortCode ShortCode of Organisation
   * @returns {Object} organisation Resulting object with schedule times
   * @returns {Array} organisation.scheduleTimes
   */
  async getTimings(shortCode) {
    const body = {
      query: `query {
        organisation {
          schedules {
            name
            _id
            actualStatementDay
          }
          scheduleTimes {
            day
            hour
          }
          thanksForPayingTimes {
            day
            hour
          }
          monthlyStatementTimes {
            day
            hour
          }
          scheduleHolidays
        }
      }`,
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data.organisation;
  },

  /**
   * @memberof TimingService
   * @name setTimings
   * @param {String} shortCode ShortCode of Organisation
   * @param {Array} scheduleTimings New hour to send chasers
   */
  setTimings(shortCode, scheduleTimings, chaseTime, scheduleHolidays) {
    const timings = [...Array(7)].map((_, i) => {
      return {
        day: i,
        hour: chaseTime,
      };
    });

    const body = {
      query: `mutation setTimings(
        $scheduleTimings: [ScheduleTimingType],
        $thanksForPayingTimes: [ScheduleTimingType],
        $monthlyStatementTimes: [ScheduleTimingType],
        $scheduleHolidays: Boolean!
      ) {
        setTimings(
          scheduleTimings: $scheduleTimings,
          scheduleHolidays: $scheduleHolidays,
          thanksForPayingTimes: $thanksForPayingTimes,
          monthlyStatementTimes: $monthlyStatementTimes
        ) {
          ShortCode
        }
      }`,
      variables: {
        scheduleTimings,
        scheduleHolidays,
        thanksForPayingTimes: timings,
        monthlyStatementTimes: timings,
      },
    };
    return ApiService.orgEndpoint(shortCode).post('/', body);
  },
  async checkTimings(shortCode, scheduleTimings, chaseTime, scheduleHolidays) {
    const timings = [...Array(7)].map((_, i) => {
      return {
        day: i,
        hour: chaseTime,
      };
    });

    const body = {
      query: `mutation checkTimingsStructure(
        $scheduleTimings: [ScheduleTimingType],
        $thanksForPayingTimes: [ScheduleTimingType],
        $monthlyStatementTimes: [ScheduleTimingType],
        $scheduleHolidays: Boolean!
      ) {
        checkTimingsStructure(
          scheduleTimings: $scheduleTimings,
          scheduleHolidays: $scheduleHolidays,
          thanksForPayingTimes: $thanksForPayingTimes,
          monthlyStatementTimes: $monthlyStatementTimes
        ) 
      }`,
      variables: {
        scheduleTimings,
        scheduleHolidays,
        thanksForPayingTimes: timings,
        monthlyStatementTimes: timings,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);

    return data.checkTimingsStructure;
  },
};

export default TimingService;
